import React, { useRef, useState, useEffect } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { HashLoader } from "react-spinners";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useCreateForumMutation,
  useDeleteForumMutation,
  useFetchForumsQuery,
  useUpdateForumMutation,
  useFetchCollegesQuery,
} from "../../store/api/apiSlice";
import { Button as CustomBtn, Input } from "../../ui";

const ForumManagement = () => {
  const { data: universitiesData } = useFetchCollegesQuery();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const { data, isLoading, error, refetch } = useFetchForumsQuery();
  const [createForum] = useCreateForumMutation();
  const [updateForum] = useUpdateForumMutation();
  const [deleteForum] = useDeleteForumMutation();
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [currentForum, setCurrentForum] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedFavoriteSport, setSelectedFavoriteSport] = useState("");
  const [favSports, setFavSports] = useState([]);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const [schoolName, setSchoolName] = useState("");
  const [saveButton, setSaveButton] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedForum, setSelectedForum] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [members, setMembers] = useState([]);

  const titleRef = useRef();
  const collegeIdRef = useRef();
  const sportsIdRef = useRef();

  const tagsRef = useRef();
  const descriptionRef = useRef();
  const statusRef = useRef();
  const slugRef = useRef();
  const collegeList = universitiesData?.university || [];
  useEffect(() => {
    const fetchFavSports = async () => {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      try {
        const response = await fetch(`${baseUrl}/api/sports/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setFavSports(data.sports);
        } else {
        }
      } catch (error) {}
    };
    fetchFavSports();
  }, []);
  const openParticipantsModal = (event, forum) => {
    event.stopPropagation();
    setParticipants(forum.members);
    console.log(forum.members);
    setShowParticipantsModal(true);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      addTag(inputValue.trim());
      setInputValue("");
    }
  };
  const handleInputChange2 = (e) => {
    setInputValue(e.target.value);
  };
  const addTag = (tag) => {
    if (!tags.includes(tag)) {
      setTags((prevTags) => [...prevTags, tag]);
    }
  };

  const removeTag = (tagToRemove) => {
    setTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };
  const closeParticipantsModal = () => {
    setShowParticipantsModal(false);
    setParticipants([]);
  };

  const openModal = (forum = null) => {
    setSelectedForum(forum);

    setSchoolName(forum.collegeId);

    setSelectedFavoriteSport(forum.sportsId);
    setTags(forum.tags || []);
    setInputValue("");
    setModalOpen(true);
    setIsCreating(!forum);
  };

  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setSelectedForum(null);
    setIsCreating(false);
  };
  const openViewModal = async (id) => {
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(`${baseUrl}/api/forums/get-single/${id}`, {
        headers,
      });
      if (response.ok) {
        const data = await response.json();
        setCurrentForum(data);
        console.log("data.Forum", data);
        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch banner details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching banner details.");
    }
  };
  const closeViewModal = () => {
    setSaveButton(false);
    setViewModalOpen(false);
    setCurrentForum(null);
  };
  const handleInputChange = (e) => {
    setSelectedForum((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    setSaveButton(true);

    e.preventDefault();

    const forumData = {
      title: titleRef.current.value,
      collegeId: schoolName,
      sportsId: selectedFavoriteSport,

      tags: tags.map((tag) => tag.trim()),
      description: descriptionRef.current.value,
      status: statusRef.current.checked,
      slug: slugRef.current.value,
    };

    try {
      if (isCreating) {
        await createForum({ forumData }).unwrap();
        setSaveButton(false);

        toast.success("Forum created successfully!");
      } else {
        await updateForum({ id: selectedForum._id, forumData }).unwrap();
        setSaveButton(false);
        toast.success("Forum updated successfully!");
      }
      refetch();
      closeModal();
    } catch (error) {
      setSaveButton(false);

      toast.error("Error saving forum:", error);
    }
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await deleteForum(id).unwrap();
      refetch();
      toast.success("Forum deleted successfully");
    } catch (error) {
      toast.error("Error deleting forum:", error);
    }
  };

  const handleUpdate = (event, forum) => {
    event.stopPropagation();
    openModal(forum);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <HashLoader color="#00b386" size={70} />
      </div>
    );
  }

  if (error) {
    return <h1>Error loading forums.</h1>;
  }

  const forumsList = data?.forums || [];
  const filteredForums = forumsList.filter((forum) =>
    forum.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredForums.length / itemsPerPage);
  const paginatedForums = filteredForums.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="d-flex justify-content-between pb-4 gap-4 pt-4">
        <Form.Control
          type="text"
          placeholder="Search by title..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="table-container">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Title</th>
              <th>School Name</th>
              <th>Sports</th>
              <th>Creator Name</th>
              <th>Tags</th>
              <th>Status</th>
              <th>Slug</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedForums.map((forum) => (
              <tr
                key={forum._id}
                onClick={() => openViewModal(forum._id)}
                style={{ cursor: "pointer" }}
              >
                <td>{forum.title}</td>
                <td>{forum.schoolName}</td>
                <td>{forum.sportsName}</td>
                <td>
                  {forum.creatorId &&
                  forum.creatorId.firstName &&
                  forum.creatorId.lastName
                    ? `${forum.creatorId.firstName} ${forum.creatorId.lastName}`
                    : "Unknown Creator"}
                </td>
                <td>{forum.tags.join(", ")}</td>
                <td>{forum.status ? "Active" : "Inactive"}</td>
                <td>{forum.slug}</td>
                <td>
                  <div
                    className="admin_Actions_gap"
                  >
                    <img
                      className="Update-delete-icon"
                      onClick={(event) => openParticipantsModal(event, forum)}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/visible--v1.png"
                      alt="visible--v1"
                    />

                    <img
                      className="Update-delete-icon"
                      onClick={(event) => handleUpdate(event, forum)}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                      alt="create-new"
                    />

                    <img
                      className="Update-delete-icon"
                      onClick={(e) => handleDelete(e, forum._id)}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                      alt="filled-trash"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div
          className="pagination-controls forumManagemnet_pagination"
         
        >
          {Array.from({ length: totalPages }, (_, index) => (
            <Button
              key={index}
              variant={
                index + 1 === currentPage ? "primary" : "outline-primary"
              }
              onClick={() => handlePageChange(index + 1)}
              className="me-2"
            >
              {index + 1}
            </Button>
          ))}
        </div>

        {isModalOpen && (
          <CustomModal isOpen={isModalOpen} onClose={closeModal}>
            <h3>{isCreating ? "Create Forum" : "Update Forum"}</h3>
            <CustomForm onSubmit={handleSubmit}>
              <div
                className="forumManagement_form_cont"
              >
                <label
                 className="forumManagement_form_label"
                >
                  Title
                </label>
                <Input
                  name="title"
                  type="text"
                  defaultValue={selectedForum?.title}
                  ref={titleRef}
                  onChange={handleInputChange}
                />
              </div>
              <div
                className="forumManagement_form_cont"
              >
                <label
                  className="forumManagement_form_label"
                >
                  School Name
                </label>
                <Form.Group controlId="schoolName">
                  <Form.Control
                    style={{ width: "208px" }}
                    as="select"
                    value={schoolName}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      console.log("Dropdown selected value:", selectedValue);
                      setSchoolName(selectedValue);
                      setSelectedForum((prev) => ({
                        ...prev,
                        collegeId: selectedValue,
                      }));
                    }}
                  >
                    <option>Select a school</option>
                    {collegeList.map((college) => (
                      <option key={college._id} value={college._id}>
                        {college.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </div>
              <div
                className="forumManagement_form_cont"
              >
                <label
                 className="forumManagement_form_label"
                >
                  Sports
                </label>
                <Form.Group controlId="sports">
                  <Form.Control
                    style={{ width: "208px" }}
                    as="select"
                    value={selectedFavoriteSport}
                    onChange={(e) => {
                      setSelectedFavoriteSport(e.target.value);
                      setSelectedForum((prev) => ({
                        ...prev,
                        sportsId: e.target.value,
                      }));
                    }}
                  >
                    <option>Select a sport</option>
                    {favSports.map((sport) => (
                      <option key={sport._id} value={sport._id}>
                        {sport.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </div>
              <div
              className="forumManagement_form_cont"
              >
                <label
                  className="forumManagement_form_label"
                >
                  Creator ID
                </label>
                <Input
                  name="creatorId"
                  type="text"
                  defaultValue={
                    selectedForum?.creatorId
                      ? `${selectedForum.creatorId.firstName} ${selectedForum.creatorId.lastName}`
                      : ""
                  }
                  disabled={true}
                />
              </div>
              <div
                className="forumManagement_form_cont"
              >
                <label
                 className="forumManagement_form_label"
                >
                  Tags{" "}
                </label>
                <div
                  className="forumManagement_form_tags"
                >
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="forumManagement_form_tag_span"
                    >
                      {tag}
                      <button
                        onClick={() => removeTag(tag)}
                       className="forumManagement_form_remove"
                      >
                        x
                      </button>
                    </span>
                  ))}
                  <input
                    type="text"
                    placeholder="Enter tags"
                    value={inputValue}
                    onChange={handleInputChange2}
                    onKeyDown={handleKeyDown}
                    style={{ border: "none", outline: "none", flex: "1" }}
                  />
                </div>
              </div>
              <div
               className="forumManagement_form_cont"
              >
                <label
                 className="forumManagement_form_label"
                >
                  Description
                </label>
                <Input
                  name="description"
                  type="text"
                  defaultValue={selectedForum?.description}
                  ref={descriptionRef}
                  onChange={handleInputChange}
                />
              </div>
              <div
                className="forumManagement_form_cont"
              >
                <label
                  className="forumManagement_form_label"
                >
                  Status
                </label>
                <Form.Check
                  type="checkbox"
                  name="status"
                  defaultChecked={selectedForum?.status}
                  ref={statusRef}
                  onChange={handleInputChange}
                />
              </div>
              <div
               className="forumManagement_form_cont"
              >
                <label
                  className="forumManagement_form_label"
                >
                  Slug
                </label>
                <Input
                  name="slug"
                  type="text"
                  defaultValue={selectedForum?.slug}
                  ref={slugRef}
                  onChange={handleInputChange}
                />
              </div>
              <div
                className="forumManagement_form_cancel"
              >
                <Button variant="secondary" onClick={closeModal}>
                  Cancel
                </Button>
                <CustomBtn
                  loading={saveButton}
                  type="submit"
                  style={{ marginLeft: "10px" }}
                >
                  Save
                </CustomBtn>
              </div>
            </CustomForm>
          </CustomModal>
        )}

        {showParticipantsModal && (
          <CustomModal
            isOpen={showParticipantsModal}
            onClose={closeParticipantsModal}
          >
            <h3>Participants</h3>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>User Name</th>
                </tr>
              </thead>
              <tbody>
                {participants.length > 0 ? (
                  participants.map((participant) => (
                    <tr key={participant?._id}>
                      <td>
                        {participant?.userId?.firstName &&
                        participant?.userId?.lastName
                          ? `${participant.userId.firstName} ${participant.userId.lastName}`
                          : "No Participant"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>No Participants</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CustomModal>
        )}
        {viewModalOpen && (
          <CustomModal isOpen={viewModalOpen} onClose={closeViewModal}>
            <div className="forumManagement_form_detail">
              <h3>Forum Details</h3>
              <p>
                <strong>Title:</strong> {currentForum?.forum?.title}{" "}
              </p>
              <p>
                <strong>School Name:</strong> {currentForum?.forum?.schoolName}{" "}
              </p>
              <p>
                <strong>Sport:</strong> {currentForum?.forum?.sportsName}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {currentForum?.forum?.status ? "Yes" : "No"}
              </p>
              <p>
                <strong>Tags:</strong> {currentForum?.forum?.tags.join(", ")}{" "}
              </p>
              <p>
                <strong>Team Id:</strong> {currentForum?.forum?.private_team}
              </p>
            </div>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default ForumManagement;
